const ENDPOINT_MY_TEACHERS = '/secure/centers/:centerId/teachers'
const ENDPOINT_SEARCH_TEACHERS = '/teacher/search/:teacherParam'
const ENDPOINT_MANAGE_TEACHER_IN_CENTER =
  '/secure/centers/:centerId/teachers/:teacherId'
const ENDPOINT_TEACHER_CENTERS = '/secure/centers-teacher/:teacherId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchMyTeachers({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_MY_TEACHERS.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async searchTeachers({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SEARCH_TEACHERS.replace(':teacherParam', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async requestTeacherAuthorization({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.put(
        ENDPOINT_MANAGE_TEACHER_IN_CENTER.replace(
          ':centerId',
          payload.centerId
        ).replace(':teacherId', payload.teacherId),
        { authorization: payload.authorization }
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async removeTeacherFromCenterTeam({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_MANAGE_TEACHER_IN_CENTER.replace(
          ':centerId',
          payload.centerId
        ).replace(':teacherId', payload.teacherId)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async addTeacherToCenterTeam({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_MANAGE_TEACHER_IN_CENTER.replace(
          ':centerId',
          payload.centerId
        ).replace(':teacherId', payload.teacherId)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchTeacherCenters({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_TEACHER_CENTERS.replace(':teacherId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
